import { NOTIFICATION_TYPE } from '../../../constants/common'

export const NOTIFICATION_DEFAULT_TYPE = NOTIFICATION_TYPE.info

export const NOTIFICATION_DEFAULT_TIMEOUT = 3000
